import React from 'react';
// 公共组件
import CtButton from './../CtButton';
// css
import './css/index.scss';

export default function MdBanner(props) {
  const { data } = props;
  return (
    <div className="material-banner">
      <div className="material-banner__img"></div>
      <div className="material-banner__inner">
        <div className="material-banner__info">
          <div className="material-banner__info-title">{data.title}</div>
          <div className="material-banner__info-des">{data.des}</div>
          {data.btnText && (
            <div className="material-banner__info-btn">
              <CtButton
                size="xl"
                hotrep="support.connect.btn.faqa"
                onClick={() =>
                  window.open(
                    'https://cloud.tencent.com/online-material?from=connect-banner'
                  )
                }
              >
                {data.btnText}
              </CtButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
